export default __webpack_public_path__ + "static/media/client-5.70bf909c.png";